var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isOpen)?_c('div',{staticClass:"px-4 py-2 mb-4 border rounded",class:_vm.colors[_vm.type]},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }